import React from 'react';
import {Link} from 'react-router-dom';
import {UiuxShoeStore} from '../../components/UIUX/uiux';


const shoeStorePage = () => {
  return (
    <div className='uiux-p-wrapper'>
        <h1 className='uiux-p-header'>UI/UX - Omni-Shoe</h1>
        <div className='uiux-p-single'>
          <br/>
          <p className='uiux-p-single-text'>Check back soon for more information.</p>
          <br/>
          <Link to="/uiux" className="fa-solid fa-arrow-left uiux-p-single-back" key="back"></Link>
          < UiuxShoeStore />
        </div>
    </div>
  )
}

export default shoeStorePage